import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { useState, useEffect, memo } from "react";
import { useEventManagerContext } from "../../context/eventContext";
import KsbDialogActions from "../../../../2_ksbHub/components/KsbDialogActions";

function LockEventDialog({ open, onClose, onConfirm }) {
  const { selectedEvent } = useEventManagerContext();

  const [unlockTime, setUnlockTime] = useState("");
  const [lockStudents, setLockStudents] = useState(false);
  const [lockTeachers, setLockTeachers] = useState(false);

  /**
   * ✅ Reset everything when dialog opens
   */
  useEffect(() => {
    if (!open) return;

    const pad = (n) => String(n).padStart(2, "0");

    // ✅ unlockTime
    if (selectedEvent?.unlockTime) {
      const d = new Date(selectedEvent.unlockTime);

      setUnlockTime(
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
          d.getHours(),
        )}:${pad(d.getMinutes())}`,
      );
    } else {
      // ✅ NEW: +1 minute
      const now = new Date();
      now.setMinutes(now.getMinutes() + 1);

      setUnlockTime(
        `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
          now.getDate(),
        )}T${pad(now.getHours())}:${pad(now.getMinutes())}`,
      );
    }

    // ✅ lock states (SAFE fallback)
    setLockStudents(Boolean(selectedEvent?.lockForStudents));
    setLockTeachers(Boolean(selectedEvent?.lockForTeachers));
  }, [open, selectedEvent]);

  /**
   * ✅ Dynamic description (FIXED)
   */
  const getStatusText = () => {
    if (!lockStudents && !lockTeachers) {
      return "Event ist für alle freigegeben";
    }

    if (lockStudents && lockTeachers) {
      return "Event ist für alle gesperrt";
    }

    if (lockStudents) {
      return "Event ist für Schülerinnen gesperrt";
    }

    if (lockTeachers) {
      return "Event ist für Lehrpersonen gesperrt";
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Event konfigurieren</DialogTitle>

      <DialogContent>
        <TextField
          type="datetime-local"
          label="Freigeben um"
          value={unlockTime}
          onChange={(e) => setUnlockTime(e.target.value)}
          fullWidth
          sx={{ mt: 2 }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={lockStudents}
              onChange={(e) => setLockStudents(e.target.checked)}
            />
          }
          label="Für Schülerinnen sperren"
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={lockTeachers}
              onChange={(e) => setLockTeachers(e.target.checked)}
            />
          }
          label="Für Lehrpersonen sperren"
        />

        {/* ✅ FIXED STATUS TEXT */}
        <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
          {getStatusText()}
        </Typography>
      </DialogContent>

      <KsbDialogActions
        onCancel={onClose}
        onConfirm={() =>
          onConfirm({
            unlockTime,
            lockForStudents: lockStudents,
            lockForTeachers: lockTeachers,
          })
        }
        confirmLabel={lockStudents || lockTeachers ? "Sperren" : "Freigeben"}
        confirmColor={lockStudents || lockTeachers ? "warning" : "success"}
      />
    </Dialog>
  );
}

export default memo(LockEventDialog);
